import type { AddressModel } from '../../types/court/court'

type AddressLabels = {
  number: string
  floor: string
  apartment: string
}

export const formatAddress = (
  address: AddressModel | null | undefined,
  labels: AddressLabels
): string => {
  if (!address) {
    return ''
  }

  const street = [
    address.street,
    address.number && `${labels.number} ${address.number}`,
  ]
    .filter(Boolean)
    .join(' ')

  return [
    street,
    address.floor && `${labels.floor} ${address.floor}`,
    address.apartment && `${labels.apartment} ${address.apartment}`,
    address.city,
    address.county,
    address.postalCode,
  ]
    .filter(Boolean)
    .join(', ')
}

const hasValue = (value?: string) => Boolean(value?.trim())

export const REQUIRED_ADDRESS_FIELDS = [
  'street',
  'number',
  'city',
  'county',
  'postalCode',
] as const satisfies readonly (keyof AddressModel)[]

export const hasCompleteBillingAddress = (
  address?: AddressModel | null
): boolean =>
  Boolean(
    address &&
      REQUIRED_ADDRESS_FIELDS.every(field => hasValue(address[field]))
  )
